/** @format */

import apiSlice from './api-slice';

// apiSlice.enhanceEndpoints({
//    addTagTypes: ['User'],
// });
export const accountsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (params) => ({
        url: '/account/login',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['Account']
    }),

    logout: builder.mutation({
      query: (params) => ({
        url: '/account/logout',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['Account']
    }),
    getMe: builder.query({
      query: () => ({
        url: '/account/me',
        method: 'GET'
      }),
      providesTags: ['Account']
    }),

    getProfile: builder.query({
      query: () => ({
        url: '/account',
        method: 'GET'
      }),
      providesTags: ['Account']
    }),

    getAccountPermissions: builder.query({
      query: () => ({
        url: '/account/permissions',
        method: 'GET'
      })
      // providesTags: ['Account']
    }),
    completeRegister: builder.mutation({
      query: (params) => ({
        url: '/account/complete',
        method: 'PUT',
        body: params
      }),
      invalidatesTags: ['Account']
    }),

    revoke: builder.query({
      query: () => ({
        url: `/account/revoke`,
        method: 'GET'
      }),
      invalidatesTags: ['Account']
    }),

    acceptResetPassword: builder.query({
      query: () => ({
        url: `/account/acceptResetPassword`,
        method: 'GET'
      }),
      invalidatesTags: ['Account']
    }),

    cancelResetPassword: builder.query({
      query: () => ({
        url: `/account/cancelResetPassword`,
        method: 'GET'
      }),
      invalidatesTags: ['Account']
    }),

    resetPassword: builder.mutation({
      query: (password) => ({
        url: `/account/resetPassword`,
        method: 'PATCH',
        body: { password }
      }),
      invalidatesTags: ['Account']
    }),

    changePassword: builder.mutation({
      query: (params) => ({
        url: `/account/changePassword`,
        method: 'PATCH',
        body: params
      }),
      invalidatesTags: ['Account']
    }),

    setZCodeConnect: builder.mutation({
      query: (params) => ({
        url: `/account/setZCodeConnect`,
        method: 'PATCH',
        body: params
      }),
      invalidatesTags: ['Account']
    }),

    updateProfile: builder.mutation({
      query: (params) => ({
        url: '/account/updateProfile',
        method: 'PATCH',
        body: params
      }),
      invalidatesTags: ['Account']
    }),

    updateAvatar: builder.mutation({
      query: (params) => ({
        url: '/account/avatar',
        method: 'PATCH',
        body: params
      }),
      invalidatesTags: ['Account']
    })
  }),
  overrideExisting: false
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useGetMeQuery,
  useLazyGetMeQuery,
  useGetProfileQuery,
  useLazyRevokeQuery,
  useLazyAcceptResetPasswordQuery, // thay thế bằng cookie
  useLazyCancelResetPasswordQuery,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useUpdateProfileMutation,
  useUpdateAvatarMutation,

  useLazyGetAccountPermissionsQuery,
  useCompleteRegisterMutation,
  useSetZCodeConnectMutation
} = accountsApi;
